var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPeopleTabInactive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "users-medical",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.2,
    viewBox: "0 0 16 13.2",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "users-medical-light-full",
    d: "M8,80.8a2,2,0,1,1-2,2A2,2,0,0,1,8,80.8Zm0,4.8a2.8,2.8,0,1,0-2.8-2.8A2.8,2.8,0,0,0,8,85.6Zm-.6,2h.635a4.8,4.8,0,0,1,.465-.8H7.4a3.8,3.8,0,0,0-3.8,3.8v.6a.4.4,0,0,0,.8,0v-.6A3,3,0,0,1,7.4,87.6Zm5.613-2.763a4.908,4.908,0,0,1,.9.2A2.4,2.4,0,0,0,12,81.2a2.278,2.278,0,0,0-.323.022,3.931,3.931,0,0,1,.245.78c.028,0,.053,0,.08,0a1.6,1.6,0,0,1,1.012,2.838ZM4,81.2a2.4,2.4,0,1,0,1.215,4.47,4.044,4.044,0,0,1-.525-.625A1.584,1.584,0,0,1,4,85.2,1.6,1.6,0,1,1,4,82c.028,0,.052,0,.08,0a3.931,3.931,0,0,1,.245-.78,2.279,2.279,0,0,0-.323-.022Zm-.265,6H3.6A3.6,3.6,0,0,0,0,90.8v.4a.4.4,0,0,0,.8,0v-.4a2.8,2.8,0,0,1,2.3-2.755A4.966,4.966,0,0,1,3.735,87.2Zm8.665-.4a2.8,2.8,0,1,1-2.8,2.8A2.8,2.8,0,0,1,12.4,86.8Zm0,6.4a3.6,3.6,0,1,0-3.6-3.6A3.6,3.6,0,0,0,12.4,93.2Zm-.268-5.4a.4.4,0,0,0-.4.4v.732H11a.4.4,0,0,0-.4.4v.533a.4.4,0,0,0,.4.4h.733V91a.4.4,0,0,0,.4.4h.533a.4.4,0,0,0,.4-.4v-.733H13.8a.4.4,0,0,0,.4-.4v-.533a.4.4,0,0,0-.4-.4h-.733V88.2a.4.4,0,0,0-.4-.4Z",
    transform: "translate(0 -80)",
    fill: "#737373"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeopleTabInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/people-tab-inactive.301f0a904f531435022ce95dc4b9c002.svg";